/* eslint-disable sonarjs/no-duplicate-string */
export enum TicketingStepName {
  GeneralInformations = "general-informations",
  Rates = "tickets",
  EventCustomization = "customization",
  Review = "review",
  AdvancedParameters = "advanced-parameters",
  Translations = "translations",
}

export enum TicketingStepKeys {
  GeneralInformation = "stepper.generalInformations",
  Rates = "stepper.tickets",
  EventCustomization = "stepper.customization",
  Review = "stepper.review",
  AdvancedParameters = "stepper.advancedParameters",
  Translations = "stepper.translations",
  Items = "stepped.items",
  Memberships = "stepper.memberships",
}

export const TicketingStepKeyToNameMap = {
  [TicketingStepKeys.GeneralInformation]: TicketingStepName.GeneralInformations,
  [TicketingStepKeys.Rates]: TicketingStepName.Rates,
  [TicketingStepKeys.Items]: TicketingStepName.Rates,
  [TicketingStepKeys.Memberships]: TicketingStepName.Rates,
  [TicketingStepKeys.EventCustomization]: TicketingStepName.EventCustomization,
  [TicketingStepKeys.Review]: TicketingStepName.Review,
  [TicketingStepKeys.AdvancedParameters]: TicketingStepName.AdvancedParameters,
  [TicketingStepKeys.Translations]: TicketingStepName.Translations,
};

export enum DonationFormStepName {
  GeneralInformations = "general-informations",
  Customization = "customization",
  Review = "review",
  AdvancedParameters = "advanced-parameters",
  Translations = "translations",
}

export enum DonationFormStepKeys {
  GeneralInformation = "stepper.generalInformations",
  FormCustomization = "stepper.customization",
  Review = "stepper.review",
  AdvancedParameters = "stepper.advancedParameters",
  Translations = "stepper.translations",
}

export const DonationFormStepKeyToNameMap = {
  [DonationFormStepKeys.GeneralInformation]: DonationFormStepName.GeneralInformations,
  [DonationFormStepKeys.FormCustomization]: DonationFormStepName.Customization,
  [DonationFormStepKeys.Review]: DonationFormStepName.Review,
  [DonationFormStepKeys.AdvancedParameters]: DonationFormStepName.AdvancedParameters,
  [DonationFormStepKeys.Translations]: DonationFormStepName.Translations,
};
